import { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { supabase } from '../../supabaseClient';
import { useCode } from '../../contexts/Code';

export default function UploadPhoto({ onUpload }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const { code } = useCode();

  const handleFileInputChange = (event) => {
    setSelectedFiles(Array.from(event.target.files));
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) return;

    const uploadPromises = selectedFiles.map(async (file) => {
      const fileName = `${code}/${Date.now()}_${file.name}`;
      const { data, error: checkError } = await supabase.storage
        .from('photos')
        .list(code, { search: file.name });

      if (checkError) {
        console.log('Error checking file:', checkError);
        return;
      }

      if (data.length > 0) {
        return;
      }

      const { error: uploadError } = await supabase.storage
        .from('photos')
        .upload(fileName, file);

      if (uploadError) {
        console.log('Error uploading file:', uploadError);
        setSnackbarMessage(code == 45 ? `Error uploading` : `Error al subir Imagen`);
        setSnackbarSeverity('error');
      } else {
        console.log('File uploaded successfully!');
        setSnackbarMessage(code == 45 ? `File uploaded successfully!` : `Archivo subido exitosamente!`);
        setSnackbarSeverity('success');
        // Refresh the gallery to show the newly uploaded image
        onUpload();
      }
      setOpenSnackbar(true);
    });

    await Promise.all(uploadPromises);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{ mt: 0, p: 2 }}
    >
      <Grid item xs>
        <TextField
          type="file"
          onChange={handleFileInputChange}
          variant="outlined"
          fullWidth
          inputProps={{
            accept: 'image/*',
            multiple: true,
          }}
        />
      </Grid>
      <Grid item>
        <Button variant="contained" onClick={handleUpload}>
          {code == 45 ? 'Upload' : 'Subir'}
        </Button>
      </Grid>
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
}